import { Empty, Icon, Input } from "antd";
import React, { useMemo, useState } from "react";
import { Container } from "./styles";

// Lista de cartões (uma por piquete) usada no lugar da tabela em tablet vertical.
// Cada item precisa ter `picketName` e `lotName` (usados na busca).
const PicketCardList = ({
  items,
  getKey,
  renderCard,
  searchPlaceholder,
  emptyText,
}) => {
  const [search, setSearch] = useState("");

  const filteredItems = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return items;
    return items.filter(
      (item) =>
        (item.picketName || "").toLowerCase().includes(term) ||
        (item.lotName || "").toLowerCase().includes(term),
    );
  }, [items, search]);

  return (
    <Container>
      <Input
        allowClear
        value={search}
        prefix={<Icon type="search" />}
        placeholder={searchPlaceholder}
        onChange={(e) => setSearch(e.target.value)}
      />
      {filteredItems.length === 0 ? (
        <Empty description={emptyText} />
      ) : (
        filteredItems.map((item) => (
          <React.Fragment key={getKey(item)}>{renderCard(item)}</React.Fragment>
        ))
      )}
    </Container>
  );
};

export default PicketCardList;
